import { memo } from 'react'

import { AppPage } from 'layouts/AppPage'
import { refresh } from 'utils/refresh'
import { useTranslation } from 'utils/translation'

import { Button } from './Button'
import { FillViewport } from './FillViewport'

export const ErrorFallback = memo(() => {
  const { t } = useTranslation()
  return (
    <FillViewport>
      <AppPage>
        <div className="error-fallback">
          <div>
            <h2> {t('loading.failure')}</h2>
            <Button onClick={refresh}>{t('loading.try-again')}</Button>
          </div>
        </div>
      </AppPage>
    </FillViewport>
  )
})
